import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { updatePreset } from '@api/crowdCellPresets';

import { ICrowdCellsConfigPreset } from '@interfaces/crowdcell/crowdCells';

import { ESnackbarTypes } from '@enums/common';

import { CROWD_CELL_EDIT_PRESETS, CROWD_CELL_PRESETS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export function useEditConfigPreset(onSuccess?: () => void, onError?: () => void): {
	editConfigPreset: (preset: ICrowdCellsConfigPreset) => void;
	isPresetEditing: boolean;
} {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: editConfigPreset,
		isLoading,
	} = useMutation<ICrowdCellsConfigPreset>({
		mutationFn: updatePreset,
		onError: () => {
			if (onError) {
				onError();
			}

			dispatch(setSnackbar({
				message: responseMessages.error,
				type: ESnackbarTypes.error,
			}));
		},
		onSuccess: () => {
			if (onSuccess) {
				onSuccess();
			}

			return [
				queryClient.invalidateQueries([CROWD_CELL_PRESETS]),
			];
		},
		mutationKey: [CROWD_CELL_EDIT_PRESETS],
		invalidateQueries: [CROWD_CELL_EDIT_PRESETS],
	});

	return {
		editConfigPreset,
		isPresetEditing: isLoading,
	};
}
